import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

type ForgotPasswordDialogProps = {
  open: boolean;
  handleClose: () => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      top: -50,
    },
    dialogActions: {
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  }),
);

const ForgotPasswordDialog = ({
  open,
  handleClose,
}: ForgotPasswordDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={handleClose} className={classes.dialog}>
      <DialogTitle id="dialog-title">
        <Typography
          color="textPrimary"
          style={{ fontWeight: 'bolder' }}
          variant="h6"
        >
          Recupere seu acesso
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography color="textPrimary" variant="body1">
            Informe abaixo seu e-mail para criar uma nova senha
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            color="secondary"
            label="E-mail"
            type="email"
            fullWidth
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={() => {}}
          color="primary"
          autoFocus
          variant="contained"
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
